// extracted by mini-css-extract-plugin
export default {"coloredBars":"ColoredBars_coloredBars__FD7nM","coloredClusters":"ColoredBars_coloredClusters__wnfri"};